// extracted by mini-css-extract-plugin
export default {"expandedTextArea":"messaging-template-content-form-section__expanded-text-area__bdHC2"};